import { render, staticRenderFns } from "./ezIcon.vue?vue&type=template&id=0fac2342&scoped=true&"
import script from "./ezIcon.vue?vue&type=script&lang=js&"
export * from "./ezIcon.vue?vue&type=script&lang=js&"
import style0 from "./ezIcon.vue?vue&type=style&index=0&id=0fac2342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac2342",
  null
  
)

export default component.exports